export default __webpack_public_path__ + "static/media/timeline.c32d0270.webm";